import Vue from 'vue'
import VueRouter from 'vue-router'
import userService from '../services/user.service'
import admin from '@/store/modules/admin'
Vue.use(VueRouter)


const allowedMCFRoutes = [
  'materiales-de-alta-pureza',
  'acidos-y-reactivos-para-aplicaciones-criticas-y-analisis-de-metales-traza',
  'reactivos-de-laboratorio',
  'soluciones-valoradas',
  'soluciones-y-reactivos-preparados',
  'soluciones-para-uso-industrial'
];

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },
  {
    path: '/nosotros',
    name: 'Nosotros',
    component: () => import('../views/AboutUs'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/catalogo',
    name: 'Catalogo',
    component: () => import('../views/Catalogo'),
    meta: {
      log: false,
    }
  },

  {
    path: '/catalogo/:producto',
    name: 'Producto Individual',
    component: () => import('../views/ProductoPage'),
    meta: {
      log: false,
    }
  },
  {
    path: '/mcf',
    name: 'Marca Propia',
    component: () => import('../views/categoriasMCF'),
    meta: {
      log: false,
    }
  },
  {
    path: '/mcf/:categoria',
    name: 'Categoria Marca Propia',
    component: () => import('../views/CategoriaIndi'),
    meta: {
      log: false,
    },
    beforeEnter: (to, from, next) => {
      if (allowedMCFRoutes.includes(to.params.categoria)) {
        next();
      } else {
        next({ name: 'Error 404' });
      }
    }
  },
  {
    path: '/mcf/:categoria/:producto',
    name: 'Producto Propio',
    component: () => import('../views/ProductoPropio'),
    meta: {
      log: false,
    },
    beforeEnter: (to, from, next) => {
      if (allowedMCFRoutes.includes(to.params.categoria)) {
        next();
      } else {
        next({ name: 'Error 404' });
      }
    }
  },

  {
    path: '/carrito',
    name: 'Carrito',
    component: () => import('../views/carrito'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    },
    beforeEnter: (to, from, next) => {
      const carrito = JSON.parse(localStorage.getItem('carritoObj')) || [];

      if (carrito.length === 0) {
        next({ name: 'Catalogo' });
      } else {
        next();
      }
    }
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/login-usuario',
    name: 'login usuario',
    component: () => import('../views/userAcount/LoginUser'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    }
  },

  {
    path: '/usuario/mi-cuenta',
    name: 'Mi cuenta',
    component: () => import('../views/userAcount/miCuentaDash'),
    meta: {
      log: false,
      admin: false,
      auth: false,
      user: true,
    }
  },

  {
    path: '/usuario/cotizaciones',
    name: 'Mis cotizaciones',
    component: () => import('../views/userAcount/cotizaciones'),
    meta: {
      log: false,
      admin: false,
      auth: false,
      user: true,
    }
  },

  {
    path: '/usuario/mis-datos',
    name: 'Mis datos',
    component: () => import('../views/userAcount/datosNInput'),
    meta: {
      log: false,
      admin: false,
      auth: false,
      user: true,
    }
  },

  {
    path: '/usuario/editar',
    name: 'Editar mis datos',
    component: () => import('../views/userAcount/datosNInput'),
    meta: {
      log: false,
      admin: false,
      auth: false,
      user: true,
    }
  },

  {
    path: '/aviso-de-privacidad',
    name: 'Aviso de privacidad',
    component: () => import('../views/PoliticaPrivacidad'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    },
  },

  {
    path: '/terminos-de-uso',
    name: 'Terminos de uso',
    component: () => import('../views/PoliticaPrivacidad'),
    meta: {
      log: false,
      admin: false,
      auth: false,
    },
  },

  {
    path: '/auth',
    name: 'autentificacion',
    component: () => import('../views/Autentificacion'),
    meta: {
      log: true,
      admin: true,
      auth: false,
    }
  },

  {
    path: '/administrador',
    name: 'Dashboard',
    component: () => import('../views/Dashboard'),
    meta: {
      log: true,
      admin: true,
      auth: true,
    }
  },

  {
    path: '/error-404',
    name: 'Error 404',
    component: () => import('../views/Error404'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },

  {
    path: '*',
    redirect: { name: 'Error 404' }
  },

  {
    path: '/contacto',
    name: 'Contacto',
    component: () => import('../views/Contacto.vue'),
    meta: {
      log: false,
      admin: false,
      auth: false
    }
  },
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.user)) {
    const token = localStorage.getItem('clientToken');

    token ? next() : next('/login-usuario');
  } else {
    next();
  }
});

router.beforeEach(async (to, from, next) => {
  let meta_admin = to.matched.some(record => record.meta.admin);
  let meta_log = to.matched.some(record => record.meta.log);
  let meta_auth = to.matched.some(record => record.meta.auth);
  let tokenexp = await userService.tokenexp()
  let check = false
  let admin = false;

  let type = ''


  


  let response = await userService.getData()

  if (response.status == 'error') {
    localStorage.removeItem('tkn')
    localStorage.removeItem('ath')
  }


  if (response.status == 'success') {
    check = true;
    let isAdmin = userService.isAdmin(response.result);
    admin = isAdmin.admin;
    type = isAdmin.type;
  }

  let ath = await userService.getAth();




  if (to.path === '/login' && check) {

    next()
  }



  if (!meta_log) next();

  if (meta_log && !check) next('/login');

  if (meta_admin) {
    if (admin) {

      if (meta_auth) {
        if (ath) {
          next();
        } else {
          next('/login')
        }
      } else {
        next()
      }

    } else {
      next('/')
    }
  } else {
    next()
  }


});

export default router